import { collection, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";

type PollVotesTally = {
	totalVotes: number;
	countsByOption: Record<string, number>;
	votesByUser: Record<string, string>;
};

export function usePollVotes(
	broadcastId: string | null,
	pollId: string | null,
): PollVotesTally {
	const [votes, setVotes] = useState<Record<string, string>>({});

	useEffect(() => {
		if (!broadcastId || !pollId) return;

		const ref = collection(
			db,
			"broadcasts",
			broadcastId,
			"polls",
			pollId,
			"votes",
		);

		return onSnapshot(ref, (snapshot) => {
			const data: Record<string, string> = {};
			snapshot.docs.forEach((d) => {
				data[d.id] = d.data().option;
			});
			setVotes(data);
		});
	}, [broadcastId, pollId]);

	const optionsChosen = Object.values(votes);
	const totalVotes = optionsChosen.length;
	const countsByOption = optionsChosen.reduce<Record<string, number>>(
		(acc, option) => {
			acc[option] = (acc[option] ?? 0) + 1;
			return acc;
		},
		{},
	);

	return { totalVotes, countsByOption, votesByUser: votes };
}
